export const getProgressBarColor = (percentage: number, expectedRatio: number): string => {
  if (percentage > 100) return '#b91c1c'; // แดงเข้มมาก (เกิน 100%)
  if (percentage > 75) return '#f87171'; // แดง
  if (percentage > 60) return '#ffa500'; // ส้ม
  if (percentage > 45) return '#ffd700'; // เหลือง
  if (percentage > 30) return '#4ade80'; // เขียว
  return '#4ade80'; // ไม่มีแถบ (0%)
};